import { DropDown, SortBy } from '@/resources/assets/images';
import React, { useRef, useState } from 'react';

import '../../scenes/styles.scss';

interface SortByFilterProps {
	searchFocused: boolean;
	setSearchFocused: (n: boolean) => void;
	handleSortBySelect: (s: string) => void;
	sortByOptions: string[];
}

export default function SortByFilter({
	searchFocused,
	setSearchFocused,
	handleSortBySelect,
	sortByOptions
}: SortByFilterProps) {
	const sortByRef = useRef<HTMLDivElement | null>(null);

	const [selectedSortByFilter, setSelectedSortByFilter] =
		useState<string>('');

	const openFilter = (e: HTMLElement | null) => {
		if (!e) return;
		if (e.classList.contains('input-open')) {
			e.classList.remove('input-open');
		} else {
			e.classList.add('input-open');
		}
	};

	return (
		<div
			ref={sortByRef}
			id="communication-center-filters"
			className={`communication-center-input smaller filters !w-full ${
				searchFocused ? 'shrinked' : ''
			}`}
			onClick={e => {
				setSearchFocused(false);
				const tar = e.currentTarget;
				setTimeout(() => {
					openFilter(tar);
				}, 0);
			}}
		>
			<SortBy />
			<div className="communication-center-input-inner-div filters">
				{selectedSortByFilter || 'Sort By'}
				<DropDown className="communication-center-filter-icon-chevron" />
			</div>
			<div className="communication-center-dropdown-bg" />
			<div
				className="communication-center-list-dropdown"
				onClick={e => {
					e.stopPropagation();
				}}
				id="communication-center-list-dropdown"
			>
				<div className="communication-center-search">
					<div className="communication-center-items">
						{sortByOptions.map((option, index) => (
							<div
								className={`communication-center-list-row ${selectedSortByFilter === option ? 'selected' : ''} `}
								key={option + index}
								onClick={e => {
									openFilter(sortByRef.current);
									handleSortBySelect(option);
									setSelectedSortByFilter(option);
								}}
								id="list-dropdown"
							>
								<div className="report-list-row-title">
									{option}
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
